import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environment/environment';
import 'hammerjs';

if ((environment as { useFirebaseEmulators?: boolean }).useFirebaseEmulators) {
  localStorage.clear();
  sessionStorage.clear();
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

function markBootstrapReady(): void {
  document.body.setAttribute('data-e2e-ready', 'true');
  (window as Window & { __E2E_READY__?: boolean }).__E2E_READY__ = true;
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    markBootstrapReady();
  })
  .catch((err) => {
    if (isMobileDevice()) {
      console.error('Application bootstrap failed on mobile device', err);
    } else {
      console.error('Application bootstrap failed', err);
    }
  });
